import { cn } from "@babackapp/ui/lib/utils";
import { Column, Row } from "@react-email/components";
import useThemeContextualColors, {
  sectionToParent,
} from "../../hooks/use-theme-contextual-colors";
import formatTemplate from "../../lib/format-template";
import { DEFAULT_FONT } from "../../utils/constants";
import type { DynamicTextBlockProps } from "./types";

export default function DynamicTextEmailRenderer({
  locale,
  block,
  formatter,
  theme,
  section,
  defaultLocale,
  isEditor = false,
  isPreview = false,
}: DynamicTextBlockProps & { isEditor?: boolean }) {
  const content =
    block.content?.[locale]?.html || block.content?.[defaultLocale]?.html || "";
  const alignment = block.alignment;
  const font = block.font ?? DEFAULT_FONT;
  const colors = useThemeContextualColors(theme, sectionToParent(section));

  let processedHtml = content.replace(/<p([^>]*)><\/p>/g, "<p$1>&nbsp;</p>");

  if (isEditor && processedHtml.trim() === "") {
    processedHtml = "<p>Cliquez pour ajouter du texte</p>";
  }

  if (isPreview && processedHtml.trim() === "") {
    processedHtml = "<p style='color: " + (colors.text ?? "#999") + "; opacity: 0.5; font-style: italic;'>Contenu dynamique</p>";
  }

  if (!isEditor && !isPreview && processedHtml.trim() === "") {
    return null;
  }

  return (
    <Row>
      <Column>
        <div
          style={{ color: colors.text, fontFamily: font }}
          className={cn(
            "font-sans text-sm leading-tight text-primary m-0 p-0",
            {
              left: "text-left",
              center: "text-center",
              right: "text-right",
            }[alignment],
          )}
          dangerouslySetInnerHTML={{
            __html: formatter(formatTemplate(processedHtml)),
          }}
        />
      </Column>
    </Row>
  );
}
